import axios from "axios";
import configToken from "@/plugins/http/actions_token/config/token_api.js";
import PathUri from '@/utils/path_uri';
import moment from 'moment';
import Swal from 'sweetalert2';

const _pathUriToken = new PathUri(configToken.port, configToken.context);

const actions_token = {

    _setHeaders(config, token) {
        const fecha = new Date();
        const idTransaccion = moment(fecha).format('YYYYMMDDHHmmss');
        const fechaSolicitud = moment(fecha).format('YYYY-MM-DD HH:mm:ss');
        const ipConsumidor = sessionStorage.getItem('ipConsumidor');
        
        config.headers.common["Authorization"] = 'Bearer ' + token.access_token;
        config.headers.common["idTransaccion"] = idTransaccion;
        config.headers.common["ipConsumidor"] = ipConsumidor;
        config.headers.common["idConsumidor"] = 'core';
        config.headers.common["fechaSolicitud"] = fechaSolicitud;
     
        return config;
    },

    _ipApi() {
        const ipApi = `https://api.ipify.org`;
        return new Promise((resolve, reject) => {
            axios({
                    method: 'get',
                    url: `${ipApi}`
                })
                .then(resp => {
                    const ipConsumidor = sessionStorage.setItem('ipConsumidor', resp.data);
                    resolve(ipConsumidor);
                })
                .catch(err => {
                    reject(err)
                })
        })
    },

    _createdToken(data) {
        return new Promise((resolve, reject) => {
            const pwdToken = "l7c4s14n_l45";
            var urlencoded = new URLSearchParams();
            urlencoded.append("grant_type", "password");
            urlencoded.append("username", data.correo);
            urlencoded.append("password", data.correo+pwdToken);
            axios({
                    method: 'post',
                    url: `${configToken.baseUrl+_pathUriToken.generateUri()+'oauth/token'}`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': `Basic aWJsaXNzYXBwOiRsN2M0czE0biNjMGQz`
                    },
                    data: urlencoded,
                    redirect: 'follow'
                })
                .then(async resp => {
                    const token = {...resp.data, created: new Date().toString() };
                    sessionStorage.setItem('token', JSON.stringify(token));
                    sessionStorage.setItem('idGroup', atob(token.idGroup));
                    sessionStorage.setItem('idEmpresa', atob(token.idEmpresa));
                    sessionStorage.setItem('empresa', JSON.stringify(token.empresa));

                    this._ipApi();
                    resolve(token);
                })
                .catch(err => {
                    if (err.response && err.response.status === 400) {
                        Swal.fire({
                            icon: 'error',
                            title: 'ERROR',
                            text: 'Error de inicio de sesión. Verifica tus credenciales e intenta nuevamente.',
                            confirmButtonColor: '#6E17A5'
                        });
                    } 
                    reject(err);                    
                })
        })
    },

    _validarTiempoExpiracionToken(token) {
        // 1. tiempo creado token
        // 2. tiempo en el que se expira el token(created + expires_in)
        // 3. tiempo actual
        const _tokenCreated = new Date(token.created);
        let minutes = Math.floor(token.expires_in / 60);
        const _tokenExpired = new Date(_tokenCreated.setMinutes(_tokenCreated.getMinutes() + minutes));
        const _tokenIsExpired = new Date() > _tokenExpired;
        return _tokenIsExpired;

    },

    _refreshToken(refreshToken) {
        return new Promise((resolve, reject) => {
            var urlencoded = new URLSearchParams();
            urlencoded.append("refresh_token", refreshToken);
            urlencoded.append("grant_type", "refresh_token");
            return axios({
                    method: 'post',
                    url: `${configToken.baseUrl+_pathUriToken.generateUri()+'oauth/token'}`,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': `Basic aWJsaXNzYXBwOiRsN2M0czE0biNjMGQz`
                    },
                    data: urlencoded,
                    redirect: 'follow'
                })
                .then(resp => {
                    sessionStorage.removeItem('token');
                    const token = {...resp.data, created: new Date().toString() };
                    sessionStorage.setItem('token', JSON.stringify(token));
                    sessionStorage.setItem('idGroup', atob(token.idGroup));
                    sessionStorage.setItem('idEmpresa', atob(token.idEmpresa));
                    sessionStorage.setItem('empresa', JSON.stringify(token.empresa));

                    this._ipApi();
                    resolve(token);
                })
                .catch(() => reject('hubo un error al pedir el token'));
        });
    }
}


export default actions_token